import { render, staticRenderFns } from "./LandingPageJp.vue?vue&type=template&id=5831347c"
import script from "./LandingPageJp.vue?vue&type=script&lang=js"
export * from "./LandingPageJp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports